import { render, staticRenderFns } from "./2BreedingObjectives.vue?vue&type=template&id=538f5753&scoped=true&"
import script from "./2BreedingObjectives.vue?vue&type=script&lang=js&"
export * from "./2BreedingObjectives.vue?vue&type=script&lang=js&"
import style0 from "./2BreedingObjectives.vue?vue&type=style&index=0&id=538f5753&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f5753",
  null
  
)

export default component.exports